import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
//.input-error class is what we will toggle

class AddFirstAndLastName extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      firstName: "",
      lastName: "",
      firstNameHasError: false,
      lastNameHasError: false,
      firstNameErrorMessage: "",
      lastNameErrorMessage: ""
    }

    this.checkAndSave = this.checkAndSave.bind(this);
    this.setName = this.setName.bind(this);
  }

  componentWillMount () {
    //set name from props to state so input => onChange, we can capture
    const user = this.props.user,
      firstName = user.first_name || "",
      lastName = user.last_name || "";
    this.setState({
      firstName,
      lastName
    })
  }

  checkAndSave (event) {
    event.preventDefault();
    var newState = {} , hasError = false;
    if (2 > this.state.firstName.length) {
      newState.firstNameHasError = true;
      newState.firstNameErrorMessage = this.props.intl.formatMessage({ id: 'shared_components.add_first_and_last_name.first_use_more_chars', defaultMessage: 'Please use at least two or more characters' });
      hasError = true;
    }
    if (2 > this.state.lastName.length) {
      newState.lastNameHasError = true;
      newState.lastNameErrorMessage = this.props.intl.formatMessage({ id: 'shared_components.add_first_and_last_name.last_use_more_chars', defaultMessage: 'Please use at least two or more characters' });
      hasError = true;
    }

    if (hasError) {
      this.setState(newState);
    } else {
      const data = {};
      data.first_name = this.state.firstName;
      data.last_name = this.state.lastName;
      this.props.updateAction(this.props.user.SSOid, JSON.stringify(data), this.props.callback);
    }
  }

  setName (event) {
    var input = event.target;
    var value = input.value;
    var fieldID = input.getAttribute('id');
    var newState = {};
    if (value) {
      const currentHasErrorKey = `${fieldID}HasError`
      const currentErrorMessageKey = `${fieldID}ErrorMessage`
      newState[currentHasErrorKey] = false;
      newState[currentErrorMessageKey] = ''
    }
    newState[fieldID] = value;
    this.setState(newState);
  }

  render () {
    var firstName = this.state.firstName;
    var lastName = this.state.lastName;
    var lastNameInputClass = "col-xs-12", firstNameInputClass = "col-xs-12", lastNameErrMsg = "", firstNameErrMsg = "";
    if (this.state.firstNameHasError) {
      firstNameInputClass = firstNameInputClass + " input-error";
      firstNameErrMsg = "text-danger";
    }
    if (this.state.lastNameHasError) {
      lastNameInputClass = lastNameInputClass + " input-error";
      lastNameErrMsg = "text-danger";
    }

    return (
      <div id="add-name">
        <h3 className="text-center">
          <FormattedMessage
            id='shared_components.add_first_and_last_name.add_name'
            defaultMessage='Add Your Name'
          />
        </h3>
        <form id="add-name-form" className="col-xs-6 col-xs-offset-3">
          <div className="col-xs-12" id="first-name-area">
            <label>
              <FormattedMessage
                id='shared_components.add_first_and_last_name.first_name'
                defaultMessage='First Name'
              />
            </label>
            <input id="firstName" className={firstNameInputClass} value={firstName} placeholder={this.props.intl.formatMessage({ id: 'shared_components.add_first_and_last_name.input_first_name_placeholder', defaultMessage: 'John' })} onChange={this.setName} />
            <p className={firstNameErrMsg}>{this.state.firstNameErrorMessage}</p>
          </div>
          <div className="col-xs-12" id="last-name-area">
            <label>
              <FormattedMessage
                id='shared_components.add_first_and_last_name.last_name'
                defaultMessage='Last Name'
              />
            </label>
            <input id="lastName" className={lastNameInputClass} value={lastName} placeholder={this.props.intl.formatMessage({ id: 'shared_components.add_first_and_last_name.input_last_name_placeholder', defaultMessage: 'Doe' })} onChange={this.setName}/>
            <p className={lastNameErrMsg}>{this.state.lastNameErrorMessage}</p>
          </div>
          <div className="col-xs-12">
            <button id="save-name-btn" className="col-xs-12 btn btn-lg btn-primary" onClick={this.checkAndSave}>
              <FormattedMessage
                id='shared_components.add_first_and_last_name.button_save'
                defaultMessage='Save'
              />
            </button>
          </div>
        </form>
      </div>
    )
  }
}

export default injectIntl(AddFirstAndLastName);
